// Générateur pseudo-aléatoire à graine (mulberry32). Son état est sauvegardé
// avec la partie : recharger une sauvegarde ne change pas les tirages à venir.

export interface RandomSource {
  rngState: number;
}

export function nextRandom(source: RandomSource): number {
  let value = (source.rngState = (source.rngState + 0x6d2b79f5) | 0);
  value = Math.imul(value ^ (value >>> 15), value | 1);
  value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
  return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
}

export function randomInt(source: RandomSource, min: number, max: number): number {
  return min + Math.floor(nextRandom(source) * (max - min + 1));
}

export function pickWeighted<T>(source: RandomSource, items: T[], weight: (item: T) => number): T {
  const total = items.reduce((sum, item) => sum + weight(item), 0);
  let roll = nextRandom(source) * total;
  for (const item of items) {
    roll -= weight(item);
    if (roll < 0) return item;
  }
  return items[items.length - 1];
}
